<svg id="chevron-up" viewBox="0 0 16 16" fill="none">
  <path d="M4 10L8 6L12 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
